<template>
  <div class="video-list">
    <template v-for="(item, index) in items">
      <div class="slot" :key="index">
        <div class="title">
          <div class="name">
            <UserTag
              v-if="item.userId"
              :user-id="item.userId"
              :user-name="item.name"
              :avatar="item.avatar"
            />
            <span v-else>{{ item.name }}</span>
          </div>
        </div>
        <template>
          <ul style="padding-left: 10px">
            <li
              class="video-slot-li"
              v-for="(part, pindex) in item.parts"
              :key="pindex"
              :class="{ active: part === activePart }"
              @click="handlePartSelected(part)"
            >
              <span style="margin-right: 5px">{{$t('home.Fragment')}}{{ pindex + 1 }}</span>
              {{ part.rangeFormat }}
              <SvgIcon
                class-name="download-icon"
                icon-class="download"
                @click.native.stop="handleVideoDownload(part.url)"
              />
            </li>
          </ul>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import SvgIcon from '@/components/behavior/svg-icon/index.vue'
import UserTag from '@/components/business/user-tag/index.vue'
import { download } from '@/utils/download'

export default {
  name: 'VideoList',
  props: {
    /**
     * @type {{name: string, userId: null|string, parts: {time: string, url: null|string}[]}[]}
     */
    items: {
      type: Array,
      default: () => ([])
    }
  },
  components: {
    SvgIcon,
    UserTag,
  },
  data() {
    return {
      activePart: null
    }
  },
  methods: {
    handlePartSelected(part) {
      this.activePart = part
      this.$emit('select', part)
    },
    handleVideoDownload(val) {
      download(val)
    }
  },
  watch: {
    items: {
      handler(items) {
        this.handlePartSelected(items[0].parts[0])
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="less">
.video-list {
  background: #ffffff;
  margin-left: 20px;
  overflow-y: auto;

  .slot {
    width: 100%;
    padding: 5px;
    .title {
      margin-left: 10px;
      margin-bottom: 30px;
      border-bottom-color: #edeff2;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      .name {
        display: inline-block;
        line-height: 32px;
        text-align: center;
        min-width: 103px;
        padding: 0 12px;
        height: 32px;
        font-size: 16px;
        font-weight: 600;
        background: #edeff2;
        border-radius: 4px 4px 0px 0px;
      }
    }
    .video-slot-li {
      width: 100%;
      height: 30px;
      margin: 6px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 10px;
      border-left-width: 4px;
      border-left-color: transparent;
      border-left-style: solid;
      font-size: 16px;
      color: #949494;
      list-style-type: none;
      border-radius: 4px;

      & > .download-icon {
        margin-right: 10px;
        cursor: pointer;
      }

      &.active {
        color: #000000;
        border-left-color: #236cff;
        border-radius: 4px;
        background-color: #ebf1ff;
        font-weight: 600;
        & > .download-icon {
          color: #236cff;
        }
      }
    }

    .video-slot-ul:hover {
      cursor: pointer;
    }
  }

  & .slot:not(:first-child) {
    margin: 10px 0;
  }
}
</style>
